import React from 'react'

export default function Calendar() {
    return (
        <div>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30.0002 6.66699H10.0002C6.31826 6.66699 3.3335 9.65176 3.3335 13.3337V30.0003C3.3335 33.6822 6.31826 36.667 10.0002 36.667H30.0002C33.6821 36.667 36.6668 33.6822 36.6668 30.0003V13.3337C36.6668 9.65176 33.6821 6.66699 30.0002 6.66699Z" stroke="#BB0600" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.3335 3.3335V10.0002M26.6668 3.3335V10.0002M3.3335 16.6668H36.6668" stroke="#BB0600" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

        </div>
    )
}
